<template>
  <div>
    <Loading type="line" :center="false" v-show="loading" />
    <div>
      <b-row>
        <b-col sm="12">
          <Select title="Grupo" field="groupRent" :required="false" :markFormDirty="false" v-model="itemsRent.groupRent"
            url="/api/v1/rental/group-rent/select-all" nameNewRegister="groupRentCreateUpdate" titleNewRegister="Grupo"
            :widthNewRegister="500" :heightNewRegister="250">
            <GroupRentCreateUpdate :registerInSelect="true" v-model="itemsRent.groupRent" />
          </Select></b-col>
      </b-row>
      <b-row>
        <b-col xs="12" sm="12" md="12" lg="5" xl="5">
          <Select title="Tipo" field="type" :formName="formName" :required="true"
            :disabled="statusStock != 1 && statusStock != 2" :markFormDirty="false"
            url="/api/v1/stock/type-product/select-all" :showNewRegister="false" v-model="itemsRent.typeProduct"
            :changed="cleanProduct" />
        </b-col>
        <b-col xs="12" sm="12" md="12" lg="7" xl="7">
          <Select title="Produto" field="product" :formName="formName" :required="true" :markFormDirty="false"
            url="/api/v1/stock/product/select-all" :propsParams="{ any: itemsRent.typeProduct.id }" :disabled="(!itemsRent.typeProduct.id && statusStock != 1) ||
              statusStock != 2
              " :showNewRegister="false" v-model="itemsRent.product" />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <div>
            <EditorHtml title="Descrição" field="description" :required="false" :markFormDirty="false" :maxLength="500"
              v-model="itemsRent.description" />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="2">
          <InputNumber title="Quantidade" field="quantity" :formName="formName" :required="false"
            :disabled="statusStock == 5 || statusStock == 6" :markFormDirty="false" :maxLength="5" type="float"
            v-model="itemsRent.quantity" />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <div class="div-btn text-right">
            <Button _key="btnUpdateItemRent" type="success" title="Salvar" :disabled="!isFormValid(formName)"
              classIcon="fas fa-save" size="medium" :clicked="saveItemRent" />
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>

import InputNumber from "@nixweb/nixloc-ui/src/component/forms/InputNumber";
import Select from "@nixweb/nixloc-ui/src/component/forms/Select";
import EditorHtml from "@nixweb/nixloc-ui/src/component/forms/EditorHtml";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";

import ItemsRent from "@/components/modules/operational/items-rent/ItemsRent.js";
import GroupRentCreateUpdate from '../../rental/group-rent/GroupRentCreateUpdate.vue'

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "ItemRentOperationalUpdate",
  components: {
    InputNumber,
    Select,
    EditorHtml,
    Button,
    Loading,
    GroupRentCreateUpdate
  },
  data() {
    return {
      formName: "itemRentUpdate",
      itemsRent: new ItemsRent(),
      urlUpdate: "/api/v1/operational/items-rent/update",
      loading: true,
    };
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event"]),
    statusStock() {
      return this.itemsRent.statusStockItemsRent;
    },
  },
  methods: {
    ...mapActions("generic", ["putApi"]),
    ...mapMutations("generic", ["addEvent", "removeLoading", "hideModal"]),
    ...mapMutations("validation", ["resetValidation"]),
    saveItemRent() {
      this.itemsRent.productId = this.itemsRent.product.id;

      let params = { url: this.urlUpdate, obj: this.itemsRent };
      this.putApi(params).then((response) => {
        if (response.success) {
          this.addEvent({ name: "addedProduct" });
          this.hideModal();
        }
        this.removeLoading(["btnUpdateItemRent"]);
      });
    },
    update(data) {
      this.itemsRent = new ItemsRent();
      this.itemsRent.update(data);
    },
    cleanProduct() {
      this.itemsRent.product = { id: "", content: "" };
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "itemRentUpdate") {
          this.update(event.data);
          this.loading = true;
          let self = this;
          setTimeout(function () {
            self.loading = false;
          }, 300);
        }
      },
      deep: true,
    },
  },
};
</script>
